import type { JSX } from 'react';
import { type ControlProps, ControlType } from '../../../Form';

type GetRadioContainer = {
  fieldName: string;
  containerTitle: string;
  containerName: string;
  options: {
    value: number | string | null;
    label: string | JSX.Element;
    disabled?: boolean;
  }[];
  value: number | string;
  fieldClassName?: string;
  isMobile?: boolean;
  isSidebar?: boolean;
  isHorizontal?: boolean;
};

const getRadioContainer = (params: GetRadioContainer): ControlProps => {
  const {
    fieldName,
    containerName,
    containerTitle,
    options,
    value,
    fieldClassName,
    isMobile,
    isSidebar,
    isHorizontal,
  } = params;

  return {
    control: ControlType.CONTAINER,
    name: containerName,
    top: { text: containerTitle },
    controls: [
      {
        control: ControlType.RADIO,
        name: fieldName,
        label: { text: '' },
        className: fieldClassName,
        options,
        value,
        default: 0,
        ...(!isMobile && !isSidebar && !isHorizontal ? { columns: 2 } : {}),
        ...(isMobile || isSidebar ? { iconOnTheRight: true } : {}),
      },
    ],
  };
};

export default getRadioContainer;
